<template>
    <BaseModal ref="modal"
        @cancel="cancel" @confirm="triggerSubmit"
        v-model="isModalOpen"
        :title="title"
        :confirmButton="computedConfirmButton"
        :cancelButton="computedCancelButton"
        max-width="570px"
        persistent
    >
        <span class="primary--text">{{ $t('views.types.personalization') }}</span>

        <CalculationRuleForm
            ref="calculation_rule_form"
            v-if="isModalOpen"
            class="mt-4"
            v-model="calculationRule"
            :isFormValid.sync="isFormValid"
            @submit="confirm"
            @triggerSubmit="triggerSubmit"
            :formType="'EDIT'"
            :loading="loading"
        />
        <span v-else>{{ $t('forms.wait') }}</span>
    </BaseModal>
</template>

<script>
import CalculationRuleForm from '@/components/forms/CalculationRuleForm'
import BaseModal           from '@/components/modals/BaseModal'
import CalculationRule     from '@/models/CalculationRule'
import BaseModalMixin      from '../BaseModalMixin'

export default {
    name: 'TypeDefaultEditModal',
    mixins: [ BaseModalMixin ],
    components: { BaseModal, CalculationRuleForm },
    props: {
        calculationRule: {
            validation: value => {
                return !value || value.instanceof(CalculationRule)
            },
        },
    },
    data: vm => {
        return {
            isFormValid: false,
            title: vm.$t('views.types.Edit.title'),
            loading: false,
        }
    },
    methods: {
        triggerSubmit() {
            this.$refs.calculation_rule_form.submit()
        },
        async beforeConfirm(calculationRule) {
            if (!this.isFormValid)
                return false

            this.loading = true

            let errType
            let response = await calculationRule.update()
                .catch(err => {                    
                    if (err.message == 'Network Error') {
                        errType = 'network_error'
                        return 
                    }

                    if (err.response.data.type) {
                        errType = err.response.data.type
                        return
                    }

                    errType = 'error'
                })

            this.loading = false
            
            if (errType) {
                const definedErrors = [
                    'network_error'
                ]
                errType = definedErrors.includes(errType) ? errType : 'error'
                await new Promise((resolve) => {
                    this.$bus.$emit('alert', this.$t(`views.types.Edit.alerts.${errType}`), 'error', resolve)
                })
                return false
            }

            this.resolveValue = this.calculationRule
            return true
        },
    },
    computed: {
        computedConfirmButton() {
            return {
                label: this.$t('actions.save'),
                disabled: !this.isFormValid,
                loading: this.loading,
            }
        },
        computedCancelButton() {
            return {
                disabled: this.loading,
            }
        },
    },
}
</script>